export default __webpack_public_path__ + "static/media/game.ac987949.gif";